"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _hoc = require("@apollo/client/react/hoc");
var _flowRight = _interopRequireDefault(require("lodash/flowRight"));
var _get = _interopRequireDefault(require("lodash/get"));
var _withLocale = _interopRequireDefault(require("./withLocale"));
var _withWaitForAuthReady = _interopRequireDefault(require("./withWaitForAuthReady"));
var _apollo = require("../../apollo");
const withAnnouncements = WrappedComponent => {
  const WrappedWithUnreadHelper = class WrappedWithUnreadHelper extends _react.default.Component {
    constructor() {
      super(...arguments);
      this.getUnreads = () => {
        const announcements = (0, _get.default)(this.props, 'announcements.announcements', []);
        /* istanbul ignore next */
        if (!Array.isArray(announcements)) return [];
        return announcements.filter(item => item.isRead === false);
      };
      this.getUnreadCount = () => this.getUnreads().length;
      this.markAllRead = () => {
        if (!this.getUnreadCount()) return null;
        const ids = this.getUnreads().map(announcement => announcement.id).join(',');
        return this.props.mutate({
          variables: {
            ids
          }
        });
      };
    }
    render() {
      return /*#__PURE__*/_react.default.createElement(WrappedComponent
      // @ts-ignore
      , Object.assign({
        unreadAnnouncementsCount: this.getUnreadCount(),
        markAllAnnouncementsRead: this.markAllRead,
        announcements: this.props.announcement
      }, this.props));
    }
  };
  return (0, _flowRight.default)(_withWaitForAuthReady.default, _withLocale.default, (0, _hoc.graphql)(_apollo.announcementsQuery, {
    name: 'announcements',
    options: props => ({
      fetchPolicy: 'network-only',
      variables: {
        lang: props.locale
      }
    })
  }), (0, _hoc.graphql)(_apollo.announcementsMarkReadMutation, {
    options: props => ({
      update: proxy => {
        const data = proxy.readQuery({
          query: _apollo.announcementsQuery,
          variables: {
            lang: props.locale
          }
        });
        const announcements = data.announcements.map(item => {
          const newItem = {
            ...item
          };
          newItem.isRead = true;
          return newItem;
        });
        proxy.writeQuery({
          query: _apollo.announcementsQuery,
          variables: {
            lang: props.locale
          },
          data: {
            announcements
          }
        });
      }
    })
  }))(WrappedWithUnreadHelper);
};
var _default = exports.default = withAnnouncements;